import React from 'react';

import { FeatureFlag, useFlags } from '~/stores/use-flags/useFlags';

import { ErrorBoundaryWrapper } from '../error-boundary-wrapper/ErrorBoundaryWrapper';

interface RenderFeatureFlagProps {
  requiredFlag: FeatureFlag;
  fallback?: React.ReactNode;
  children?: React.ReactNode;
}

export const RenderFeatureFlag = ({
  requiredFlag,
  fallback = null,
  children,
}: RenderFeatureFlagProps) => {
  const requiredFlagIsEnabled = useFlags(state =>
    state.getFeatureFlagState(requiredFlag)
  );

  return (
    <ErrorBoundaryWrapper fallback={fallback}>
      {requiredFlagIsEnabled ? children : fallback}
    </ErrorBoundaryWrapper>
  );
};
